import { render, staticRenderFns } from "./AsignacionData.vue?vue&type=template&id=4f867213&"
import script from "./AsignacionData.vue?vue&type=script&lang=js&"
export * from "./AsignacionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports